import { actions } from '@store/loader';
/**
 * Loader service.
 *
 * @author Mikhail Siutsou
 * @const LoaderService
 * @category Components
 * @subcategory Loader
 */

var LoaderService = {
  /**
   * Show loader.
   *
   * @author Mikhail Siutsou
   * @param {Dispatch} dispatch dispatch.
   * @return {void}
   */
  showLoader: function showLoader(dispatch) {
    dispatch(actions.initLoaderShowing());
  },

  /**
   * Hide loader.
   *
   * @author Mikhail Siutsou
   * @param {Dispatch} dispatch dispatch.
   * @return {void}
   */
  hideLoader: function hideLoader(dispatch) {
    dispatch(actions.initLoaderHiding());
  },

  /**
   * Increase count of the requests.
   *
   * @author Mikhail Siutsou
   * @param {Dispatch} dispatch dispatch.
   * @return {void}
   */
  incRequestCounter: function incRequestCounter(dispatch) {
    dispatch(actions.initIncreasingRequestCounter());
  },

  /**
   * Decrease count of the requests.
   *
   * @author Mikhail Siutsou
   * @param {Dispatch} dispatch dispatch.
   * @return {void}
   */
  decRequestCounter: function decRequestCounter(dispatch) {
    dispatch(actions.initDecreasingRequestCounter());
  }
};
export { LoaderService };